import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function About() {

  const {t} = useTranslation('services');

  return (
    <section className="tc-about-style7">
      <div className="container">
        <div className="row gx-0 justify-content-between">
          <div className="col-lg-3">
            <div className="rotate-box" data-speed="1" data-lag="0.4">
              <Link
                href="#"
                className="rotate-circle fsz-30 rotate-text d-inline-block text-uppercase"
              >
                <svg className="textcircle" viewBox="0 0 500 500">
                  <defs>
                    <path
                      id="textcircle"
                      d="M250,400 a150,150 0 0,1 0,-300a150,150 0 0,1 0,300Z"
                    ></path>
                  </defs>
                  <text>
                    <textPath xlinkHref="#textcircle" textLength="900">
                      {t('text-circle')}
                    </textPath>
                  </text>
                </svg>
              </Link>
              <img
                src="/innerpages/assets/img/leafs.png"
                alt="Mimaria"
                className="icon"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
              <div className="text fsz-25 fw-500 mb-20">
              {t('text-near-circle')}
              </div>
              
            </div>
          </div>
          <div className="col-lg-2">
            <div className="numbers mt-5 mt-lg-0">
              <div
                className="number-card wow zoomIn slow"
                data-wow-delay="0.4s"
              >
                <h2 className="numb"> 98% </h2>
                <small> {t('happy-clients')} </small>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
